import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    deleteUserRole: [],
    loading: false,
    error: null,
}

const deleteUserRoleSlice = createSlice({
    name: "deleteUserRole",
    initialState,
    reducers: {
        fetchDeleteUserRoleSuccess: (state, action) => {
            state.loading = false
            state.deleteUserRole = action.payload;
        },
        fetchDeleteUserRoleFailure: (state, action) => {
            state.loading = false
            state.error = action.payload;
        },
    },
})

export const {
    fetchDeleteUserRoleSuccess,
    fetchDeleteUserRoleFailure,
} = deleteUserRoleSlice.actions;

export default deleteUserRoleSlice.reducer;